import { Appointment } from 'pages/appointment';
import { Clinics } from 'pages/clinics';
import { DoctorPage } from 'pages/doctor';
import { DoctorsSelection } from 'pages/doctorsSelection';
import { NotFoundPage } from 'pages/notFound';
import { Specializations } from 'pages/specializations';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { YMInitializer } from 'react-yandex-metrika';
import { YANDEX_METRIKA_ID } from 'shared/consts';


export const AppRouter = () => {
	return (
		<BrowserRouter
			future={{
				v7_startTransition: true,
				v7_relativeSplatPath: true,
			}}
		>
      {YANDEX_METRIKA_ID && <YMInitializer accounts={[Number(YANDEX_METRIKA_ID)]} />}
			<Routes>
				<Route
					path="/"
					element={<Navigate to="/specializations" replace />}
				/>
				<Route path="/specializations" element={<Specializations />} />
				<Route path="/clinics" element={<Clinics />} />
				<Route path="/appointment" element={<Appointment />} />
				<Route
					path="/doctors-selection/"
					element={<DoctorsSelection />}
				/>
				<Route
					path="/doctors-selection/:id/:view?"
					element={<DoctorPage />}
				/>
				<Route
					path="/doctor/:id/:view?"
					element={<DoctorPage />}
				/>
				<Route
					path="*"
					element={<NotFoundPage />}
				/>
			</Routes>
		</BrowserRouter>
	);
};
